import { useSelector } from 'react-redux';
import { Flex, Dropdown, Loader } from '@fluentui/react-northstar';

// Constants
import { LANGUAGE_PREFIX, TEAMS_LANGUAGE_RESOURCE } from 'CONSTANTS/teamsConstants';

// Hooks
import { useMemo } from 'react';

// Services
import { useTranslation } from 'react-i18next';

// Store
import { meetingSelector } from 'STORE/meetingSlice';

// Uitils
import { IDropdownLanguage, ISpokenLanguage } from 'UTILS/teamsInterface';

import 'FEATURES/tab/inMeeting/languageDropdown/LanguageDropdown.css';

const LanguageDropdown = ({ updateLanguage, spokenLanguages, loading }: IDropdownLanguage) => {
  // restructuring the laguge according to Dropdown component
  const structureLanguages = (spokenLanguages: ISpokenLanguage[]) => {
    return spokenLanguages?.map((spokenLanguage: ISpokenLanguage) => {
      if (!spokenLanguage?.code) return;
      return {
        header: `${spokenLanguage.name} - ${spokenLanguage.country}`,
        value: spokenLanguage.code,
        key: spokenLanguage.code,
      };
    });
  };
  // restructuring languages object
  const languages = useMemo(() => structureLanguages(spokenLanguages), [spokenLanguages]);
  const selectedLanguage = useSelector(meetingSelector.selectedSpokenLanguages);
  const { t } = useTranslation(TEAMS_LANGUAGE_RESOURCE, LANGUAGE_PREFIX.INMEETING);

  return (
    <Flex hAlign="center">
      {loading && <Loader size="small" className="languageLoader" />}
      <Dropdown
        className="languageDropdown"
        items={languages}
        placeholder={`${t('SELECT_LANGUAGE_DROPDOWN')}`}
        onChange={(e, languageSelected: any) => {
          // if previously selected language code and new selected language is same then return
          if (languageSelected.value.key === selectedLanguage?.code) return;
          // if previously selected language code and new selected language is different
          // then return new language object and update language
          return spokenLanguages.filter(
            (spokenLanguage: ISpokenLanguage) =>
              spokenLanguage?.code === languageSelected.value.key && updateLanguage(spokenLanguage)
          );
        }}
        defaultValue={structureLanguages([selectedLanguage])}
        fluid
        inverted
      />
    </Flex>
  );
};

export default LanguageDropdown;
